"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionStatus = void 0;
__exportStar(require("./subscriptions"), exports);
var SubscriptionStatus;
(function (SubscriptionStatus) {
    // Has been paid and is currently Active
    SubscriptionStatus["Active"] = "Active";
    // Has been created, but yet to receive first payment
    SubscriptionStatus["Incomplete"] = "Incomplete";
    // Soft-deletion
    SubscriptionStatus["Deleted"] = "Deleted";
    // Payment has failed and is being automatically retired
    SubscriptionStatus["FailingPayment"] = "FailingPayment";
    // Existing but un-wired to any ProcessorSubscription
    SubscriptionStatus["Paused"] = "Paused";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc3Vic2NyaXB0aW9ucy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGtEQUFnQztBQUVoQyxJQUFZLGtCQVdYO0FBWEQsV0FBWSxrQkFBa0I7SUFDNUIsd0NBQXdDO0lBQ3hDLHVDQUFpQixDQUFBO0lBQ2pCLHFEQUFxRDtJQUNyRCwrQ0FBeUIsQ0FBQTtJQUN6QixnQkFBZ0I7SUFDaEIseUNBQW1CLENBQUE7SUFDbkIsd0RBQXdEO0lBQ3hELHVEQUFpQyxDQUFBO0lBQ2pDLHFEQUFxRDtJQUNyRCx1Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBWFcsa0JBQWtCLEdBQWxCLDBCQUFrQixLQUFsQiwwQkFBa0IsUUFXN0IifQ==